/* eslint-disable import/prefer-default-export */
import { createUrl } from '_clean-code/utils/urlHelper';
import apiClient from '../../api/index';
import { IShiftService, MachineShift } from './contracts/shift.service';
import { Logger } from '_clean-code/utils/logger';

export const ShiftService: IShiftService = {
  async getShiftsByMachine(
    machineIds: number[],
    from: Date,
    end: Date
  ): Promise<MachineShift[]> {
    try {
      const response = (await apiClient.request(
        'GET',
        createUrl('/shifts')
          .addQueryParamMany('machineId', machineIds)
          .addQueryParam('start', from.toISOString())
          .addQueryParam('end', end.toISOString())
          .toStringUrl()
      )) as MachineShift[];

      return response
        ? response.map((x) => ({
            ...x,
            start: new Date(x.start),
            end: new Date(x.end)
          }))
        : [];
    } catch (error) {
      Logger.error('ShiftService::getShiftsByMachine', error);
      return [];
    }
  }
};
